/**
=========================================================
* SolisUp - Footer
=========================================================
*/

import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import Icon from '@mui/material/Icon';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import typography from 'assets/theme/base/typography';
function Footer({
  light = false,
  company = { name: 'SolisUp' },
  links = [
    { href: '/terms', name: 'Kullanım Koşulları' },
    { href: '/privacy', name: 'Gizlilik' },
    { href: 'mailto:destek@solisup.com', name: 'Destek' },
    { href: '/status', name: 'Sistem Durumu' },
  ],
}) {
  const { size } = typography;

  const textColor = light ? 'white' : 'text';
  const strongColor = light ? 'white' : 'dark';

  const renderLinks = () =>
    links.map((link) => (
      <MDBox
        key={link.name}
        component="li"
        lineHeight={1}
        sx={{
          px: { xs: 1, sm: 1.25 },
          py: { xs: 0.5, sm: 0 },
        }}
      >
        <Link
          href={link.href}
          target={link.external ? '_blank' : undefined}
          rel={link.external ? 'noreferrer' : undefined}
          underline="none"
          sx={{ display: 'inline-flex' }}
        >
          <MDTypography
            variant="button"
            fontWeight="regular"
            color={textColor}
            sx={{ opacity: 0.85, '&:hover': { opacity: 1 } }}
          >
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox width="100%" py={{ xs: 2, sm: 3 }} mt={{ xs: 2, sm: 3 }} sx={{ position: 'relative' }}>
      <MDBox
        width="100%"
        display="flex"
        flexDirection={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        gap={1.25}
        px={{ xs: 1.5, sm: 2 }}
        textAlign={{ xs: 'center', md: 'left' }}
      >
        {/* Left */}
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          color={textColor}
          fontSize={size.sm}
          sx={{ opacity: 0.9 }}
        >
          © {new Date().getFullYear()}{' '}
          <MDTypography
            component="span"
            variant="button"
            fontWeight="medium"
            color={strongColor}
            sx={{ mx: 0.5 }}
          >
            {company?.name ?? 'SolisUp'}
          </MDTypography>
          • işletmeni tek panelden yönet
          <MDBox fontSize={size.md} color={strongColor} mb={-0.5} mx={0.6}>
            <Icon color="inherit" fontSize="inherit">
              favorite
            </Icon>
          </MDBox>
        </MDBox>

        {/* Right */}
        <MDBox
          component="ul"
          sx={({ breakpoints }) => ({
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
            listStyle: 'none',
            m: 0,
            p: 0,
            gap: 0.5,
            [breakpoints.down('md')]: { mt: 0.75 },
          })}
        >
          {renderLinks()}
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
export default Footer;
// Footer.defaultProps ❌ kaldırıldı

Footer.propTypes = {
  light: PropTypes.bool,
  company: PropTypes.shape({
    name: PropTypes.string,
  }),
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      external: PropTypes.bool,
    })
  ),
};
